export default {
    map_token: "pk.eyJ1IjoicGFya2VyaG9sZGVudyIsImEiOiJja2JmZzlxZ2MwbjBjMnptdGk4M3V6N3R5In0.7a8oAHzXjzQwAWYgDUlq3Q"
}